module.exports = __webpack_public_path__ + "img/MW.317a10f4.svg";